var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.665,
    cy: 75,
    r: 75,
    fill: "#E50001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4732 38.6924C101.882 38.6924 107.892 69.9489 107.892 108.55H118.703C118.703 66.9917 107.796 33.3505 94.4414 33.3505C86.8101 33.3505 80.0691 43.4301 75.6175 59.2651C71.1659 43.4301 64.425 33.3505 56.8573 33.3505C43.5025 33.3505 32.6279 66.9599 32.6279 108.519H43.4389C43.4389 69.9171 49.385 38.6924 56.7937 38.6924C64.2024 38.6924 70.212 67.5641 70.212 103.177H80.9594C80.9594 67.5641 87.0009 38.6924 94.4096 38.6924",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcdLogo);
export default __webpack_public_path__ + "static/media/mcdLogo.f88b36ac51be29eec934609f07a5fe3b.svg";
export { ForwardRef as ReactComponent };